var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9353 8.77783V18.7778C1.9353 20.0052 2.93022 21.0001 4.15753 21.0001H19.7131C20.9404 21.0001 21.9353 20.0052 21.9353 18.7778V8.77783",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0831 21V14.3333C15.0831 13.106 14.0882 12.1111 12.8609 12.1111H10.6387C9.41136 12.1111 8.41644 13.106 8.41644 14.3333V21",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8446 8.07131L20.9623 1.48352C20.8806 1.19732 20.619 1 20.3213 1H15.8242L16.3523 7.33752C16.3697 7.54492 16.4823 7.73227 16.6611 7.83883C17.0937 8.09665 17.9411 8.57443 18.602 8.77778C19.7307 9.125 21.3807 8.99978 22.3203 8.88422C22.7111 8.83622 22.9528 8.44989 22.8446 8.07131Z",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1573 8.77778C14.7879 8.58376 15.5883 8.13988 16.0361 7.87563C16.2493 7.74984 16.3667 7.51226 16.3461 7.2656L15.824 1H8.04624L7.5241 7.2656C7.50355 7.51226 7.62094 7.74984 7.83408 7.87563C8.28187 8.13988 9.08235 8.58376 9.7129 8.77778C11.3718 9.28822 12.4985 9.28822 14.1573 8.77778Z",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90811 1.48352L1.02588 8.07131C0.917713 8.44989 1.15937 8.83622 1.55015 8.88422C2.48977 8.99978 4.13986 9.125 5.26848 8.77778C5.92934 8.57443 6.77683 8.09665 7.20935 7.83883C7.38811 7.73227 7.50085 7.54492 7.51814 7.33752L8.04626 1H3.54912C3.25147 1 2.98988 1.19732 2.90811 1.48352Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon);
export default __webpack_public_path__ + "static/media/shop_icon.dcbefd75f4a10b81aba54c881842d55e.svg";
export { ForwardRef as ReactComponent };